import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../../action/webViewContentAction.js';
import './ModalTip.css';

class ModalTip extends Component {
  static defaultProps = {
    leftButtonTitle:　'取消',
    rightButtonTitle:'确认',
    content:'',
    contentBC:'',
    onCancel:()=>{},
    onOK:()=>{},
    titleBC:'',
    title:'',
    flag:false,
  }
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
  }
  componentWillUnmount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","")
  }
  render(){
    return (
      <div>
        {this.props.flag?<div  className='containerModal_old' >
          <div className='modalView_old'>
            <div className='titleText_old'style = {{marginTop: this.props.titleBC ? 6 : 20}}>{this.props.title}
            </div>
            <div className='contentText_old' >{this.props.content}</div>
            <div className='contentTwoText_old' >{this.props.contentBC}</div>
            <div className='footView_old'>
              <p onClick={()=>this.props.onOK()}>{this.props.rightButtonTitle}</p>
            </div>
          </div>
        </div>:null
      }
      </div>
    );
  }
}


export default ModalTip



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTip.js